export default "__VITE_ASSET__0tx$gKbu__"